<script>
import VideoList from '../components/video/VideoList.vue';
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'

export default {
  name: 'Video',
  components: {
    VideoList,
    PCNavbar,
    MobileNavBar
  }
}
</script>

<template>
  <div>
    <PCNavbar />
    <MobileNavBar />
    <div class="video-page">
      <VideoList />
    </div>
  </div>
</template>

<style scoped>
.video-page {
  width: 100%;
  min-height: 100vh;
}
</style>
